import React, { useState, useCallback, useRef } from 'react';
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
import { addLocalFiles } from '../../actions/file.js'
import { getOutputTypes, getCompressAllowedTypes } from '../../dataProvider/file.js'
import UploadFileTable from './UploadFileTable.jsx'
import mime from "mime";

import uploadArrowV2 from '../../img/v2/home/upload/download-arrow.png'

import "../../scss/v2/upload.scss"

function UploadBlock(props) {

    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [url, setUrl] = useState('');
    const scrollRef = useRef(null)
    const dropzoneParent = useRef(null);

    const handleClose = () => {
        setShow(false);
        setUrl('');
    }

    return (
        <>
            <div className="upload-container">
                <MyDropzone
                    scrollRef={scrollRef}
                    dropzoneParent={dropzoneParent}
                    {...props}
                />
            </div>
            <div className="uploaded-file-container-ref" ref={scrollRef}>
                <UploadFileTable compress={props.compress} split={props.split} />
            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <p>{t('homepage.uploadModal.title')}</p>
                </Modal.Header>
                <Modal.Body>
                    <input className="input link-upload-input" id="link-upload-input" onChange={event => setUrl(event.target.value)}
                        value={url} placeholder={t('homepage.uploadModal.input.placeholder')} />
                </Modal.Body>
                <Modal.Footer>
                    <button className="button orange-button" onClick={handleClose}>{t('homepage.uploadModal.submit.button')}</button>
                </Modal.Footer>
            </Modal>
        </>
    )

}

function MyDropzone(props) {

    const { t } = useTranslation();

    const onDrop = useCallback(async acceptedFiles => {

        const executeScroll = () => {
            window.scrollTo(0, 0) //if not the second scroll will not scroll where it should
            //timeout to wait for previous scroll
            setTimeout(function () {
                if (!props.scrollRef.current) return;
                props.scrollRef.current.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' })
            }, 100);
            props.dropzoneParent.current.blur() //if not, block stays focused and element wont update
        }

        const filteredAcceptedFiles = []
        acceptedFiles.forEach(file => {
            if (getOutputTypes(mime.getType(file.name)).length === 0) return;
            filteredAcceptedFiles.push(file)
        })

        let mode = 'convert';
        if (props.compress) mode = 'compress';
        if (props.split) mode = 'split';

        await props.dispatch(addLocalFiles(filteredAcceptedFiles, mode));
        executeScroll();

    }, [props])

    const dropOptions = { onDrop }
    if (props.compress) dropOptions.accept = getCompressAllowedTypes().join(',')
    if (props.split) dropOptions.accept = "application/pdf"
    const { getRootProps, getInputProps, isDragActive } = useDropzone(dropOptions)

    return (
        <div {...getRootProps()} ref={props.dropzoneParent}>
            <input {...getInputProps()} />
            <div className="upload-file-container" key={props.files.length}>
                <div className="upload-file-circle hover-pointer">
                    <div className="upload-file-icon-container">
                        <img className="img img-fluid upload-arrow" src={uploadArrowV2} alt={uploadArrowV2} />
                    </div>
                    {
                        isDragActive ?
                            <p className="upload-file-circle-text">{t("homepage.uploadBlock.upload.drop")}</p> :
                            <p className="upload-file-circle-text">{t(`homepage.uploadBlock${!!props.format ? `.${props.format.toLowerCase()}` : ''}.upload${props.files.length > 0 ? '.after' : ''}.text`)}</p>
                    }
                </div>
                <div className="upload-file-button">
                    <button className="button orange-button">{t(`homepage.uploadBlock${!!props.format ? `.${props.format.toLowerCase()}` : ''}.upload${props.files.length > 0 ? '.after' : ''}.button`)}</button>
                </div>
            </div>
        </div>
    )
}


const mapStateToProps = state => ({ files: state.file.files, file: state.file })

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(UploadBlock)